import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'kt-bot-transaction-list',
  templateUrl: './bot-transaction-list.component.html',
  styleUrls: ['./bot-transaction-list.component.scss']
})
export class BotTransactionListComponent implements OnInit {
    htmlContent: SafeHtml = null;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: { transaction_data: any; },
        public dialogRef: MatDialogRef<BotTransactionListComponent>,
        private sanitizer: DomSanitizer
    ) { }

    ngOnInit(): void {
        if (this.data?.transaction_data?.latest_transaction_html_content) {
            this.htmlContent = this.sanitizer.bypassSecurityTrustHtml(this.data.transaction_data.latest_transaction_html_content);
        }
    }

    onCloseDialog(value = false) {
        this.dialogRef.close(value);
    }
}
